<template>
  <b-card
    v-if="page === 'summary'"
    :key="product.id"
    no-body
    :style="isOnboardingRedesign ? '' : 'background-color: rgba(242, 242, 242, 0.5)'"
    :class="isOnboardingRedesign ? 'tw-p-3 tw-rounded-xl tw-border-[#C7C7C7]' : 'py-2'"
  >
    <b-row
      no-gutters
      align-v="stretch"
    >
      <b-col
        cols="4"
        class="p-0 tw-rounded-[4px] tw-bg-[#DCD7EE]"
      >
        <div class="tw-relative tw-w-full tw-rounded-xl tw-overflow-hidden">
          <img
            class="tw-w-full tw-object-cover tw-h-[108px] md:!tw-h-[180px]"
            :src="
              product.image == null
                ? require('@/assets/images/dashboard/articlebg.png')
                : product.image
            "
            @click.prevent="selected = !selected"
          >
          <div class="tw-flex tw-justify-between tw-items-center tw-absolute tw-top-[10px] tw-left-[10px] tw-right-0">
            <div
              v-if="!isAutoSelected"
              class="tw-flex tw-gap-1"
            >
              <CustomCheckbox
                v-model="selected"
                class="product-reveal-checkbox"
              >
                <span class="tw-hidden md:tw-block tw-ml-2">
                  {{ selected ? 'Selected' : 'Select' }}
                </span>
              </CustomCheckbox>
            </div>
          </div>
        </div>
      </b-col>
      <b-col
        :cols="product.image ? '8' : '12'"
        class="d-flex flex-column justify-content-between pl-4 pr-2 h-100"
        align-self="center"
      >
        <div class="mb-2">
          <h3
            class="mb-2"
            :class="isOnboardingRedesign ? 'tw-text-lg md:tw-text-2xl' : 'tw-text-xl med-font'"
          >
            {{ product.name }}
          </h3>
          <p
            v-if="!(product.pricingdetail.nickname === 'One time payment' && onboardingPatient?.non_hrt)"
            :class="{'tw-text-lg tw-text-[#787878] tw-m-0': isOnboardingRedesign}"
          >
            <template v-if="product.pricingdetail.nickname === 'Auto-refilled every 3 months'">
              Ships every 3 months
            </template>
            <template v-else>
              {{ product.pricingdetail.nickname }}
            </template>
          </p>
        </div>
        <p class="med-font mb-0">
          <!-- med.pricingdetail.hidebillingfrequency -->
          <span
            v-if="product.pricingdetail.hasOwnProperty('hidebillingfrequency')"
            :class="isOnboardingRedesign && 'tw-text-lg'"
          >
            ${{ product.price }}
          </span>
          <span
            v-else
            :class="isOnboardingRedesign && 'tw-text-lg'"
          >
            {{
              formatPricing(
                product.pricingdetail.type,
                product.price,
                product.pricingdetail.recurring,
              )
            }}
          </span>
        </p>
      </b-col>
    </b-row>
  </b-card>
  <b-card
    v-else
    no-body
    :class="[
      selected ? 'tw-border-[#1A6A72]' : 'tw-border-[#C7C7C7]',
      mini ? 'lg:tw-max-h-[400px]' : 'lg:tw-max-h-[500px]',
      !hasProductSelected ? 'tw-opacity-50 tw-pointer-events-none tw-cursor-not-allowed' : '',
    ]"
    class="tw-rounded-2xl tw-border tw-overflow-hidden md:!tw-flex md:tw-flex-row tw-w-full lg:tw-max-h-[500px]"
  >
    <div class="tw-hidden md:tw-flex tw-gap-4 tw-py-4 tw-px-4 tw-w-full">
      <b-form-checkbox
        :id="'checkbox-' + product.id"
        v-model="selected"
        name="product-id"
        class="product-reveal-checkbox"
        :value="true"
        :unchecked-value="false"
      />
      <div class="tw-size-32 tw-overflow-hidden tw-rounded-2xl">
        <img
          class="tw-w-full tw-object-cover tw-h-full"
          :src="
            product.image == null
              ? require('@/assets/images/dashboard/articlebg.png')
              : product.image
          "
          @click.prevent="selected = !selected"
        >
      </div>
      <div class="tw-flex-1 tw-w-full">
        <div class="tw-flex tw-justify-between tw-gap-2">
          <h3
            class="tw-mb-0"
            :class="mini ? 'tw-text-2xl tw-mb-1' : 'tw-text-xl lg:tw-text-2xl'"
          >
            {{ product.name }}
          </h3>
          <h3
            class="tw-mb-0"
            :class="mini ? 'tw-text-2xl tw-mb-1' : 'tw-text-xl lg:tw-text-2xl'"
          >
            ${{ product.price }}
          </h3>
        </div>
        <div class="tw-text-lg">
          {{ product.pricingdetail.nickname }}
        </div>
        <p
          class="mb-0  tw-tracking-tight"
          :class="[
            mini
              ? 'tw-text-lg md:tw-text-base lg:tw-text-lg tw-leading-none'
              : 'tw-text-base lg:tw-text-lg',
            ['E1', 'F1', 'F2'].includes(onboardingVariant)
              ? 'tw-border-black'
              : 'tw-text-[#787878]'
          ]"
        >
          {{ product.shortdescription }}
        </p>
      </div>
    </div>
    <div
      class="md:tw-hidden tw-pt-4 tw-px-4 tw-m-4 tw-rounded-xl md:tw-w-1/2 lg:tw-w-[47%] tw-overflow-hidden md:tw-h-[250px] lg:tw-h-[300px] tw-flex tw-items-stretch"
      :class="{
        'tw-bg-[#EBF5F4]': ['C', 'D1'].includes(onboardingVariant),
        'tw-bg-[#DCD7EE]': !['C', 'D1'].includes(onboardingVariant),
      }"
    >
      <div class="tw-relative tw-w-full">
        <img
          class="tw-w-full tw-object-contain md:tw-object-cover md:tw-h-[218px] lg:tw-h-[268px]"
          :src="
            product.image == null
              ? require('@/assets/images/dashboard/articlebg.png')
              : product.image
          "
          @click.prevent="selected = !selected"
        >
        <div class="tw-flex tw-justify-between tw-items-center tw-absolute tw-top-0 tw-left-0 tw-right-0">
          <div class="tw-flex tw-gap-1">
            <CustomCheckbox
              v-if="showCustomCheckbox"
              v-model="selected"
            />
            <template v-else>
              <b-form-checkbox
                :id="'checkbox-' + product.id"
                v-model="selected"
                name="product-id"
                class="product-reveal-checkbox"
                :value="true"
                :unchecked-value="false"
              />
              <p class="tw-mb-0 tw-mt-0.5">
                {{ selected ? 'Selected' : 'Select' }}
              </p>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="md:tw-hidden md:tw-w-1/2 lg:tw-w-[53%] md:tw-py-4 tw-overflow-y-auto tw-mb-4">
      <div
        class="tw-px-6 md:tw-pl-0 md:tw-pr-4"
      >
        <h3 :class="mini ? 'tw-text-2xl tw-mb-1' : 'tw-text-xl lg:tw-text-2xl'">
          {{ product.name }}
        </h3>
        <p>
          ${{ product.price }}
          <template v-if="product.pricingdetail.nickname">
            — {{ product.pricingdetail.nickname }}
          </template>
        </p>
        <p
          class="mb-0  tw-tracking-tight"
          :class="[
            mini
              ? 'tw-text-lg md:tw-text-base lg:tw-text-lg tw-leading-none'
              : 'tw-text-base lg:tw-text-lg',
            ['E1', 'F1', 'F2'].includes(onboardingVariant)
              ? 'tw-border-black'
              : 'tw-text-[#787878]'
          ]"
        >
          {{ product.shortdescription }}
        </p>
      </div>
    </div>
  </b-card>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import CustomCheckbox from '@/components/partials/CustomCheckbox.vue';
import TreatmentSelect from '@/components/onboarding/treatments/TreatmentSelect.vue';

export default {
  components: {
    CustomCheckbox,
    TreatmentSelect
  },
  props: {
    product: {
      type: Object,
    },
    existingPricing: {
      type: String,
      default: null,
    },
    mini: {
      type: Boolean,
      default: false,
    },
    hasProductSelected: {
      type: Boolean,
      default: true,
    },
    page: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      showDescription: false,
      selectedpricing: '',
      selected: false,
      isDropdownOpen: false
      // firstSet: true,
    };
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    ...mapState('onboarding', ['onboardingPatient']),
    options() {
      if (['F2', 'F3v1', 'F3v2', 'G'].includes(this.onboardingVariant)) {
        return this.product.availablepricing.map(pricing => {
          const price = pricing.subscriptiontype === 'Quarterly' ? _.ceil(pricing.price / 3) : pricing.price;
          return {
            text: '$' + price + '/mo. - ' + pricing.name,
            value: pricing.pricingid,
          }
        });
      } else {
        return this.product.availablepricing.map(pricing => ({
          text: '$' + pricing.price + '/mo. - ' + pricing.name,
          value: pricing.pricingid,
        }));
      }
    },
    onboardingVariant() {
      return this.onboardingPatient?.flow_variant;
    },
    showCustomCheckbox() {
      return ['D1', 'D2', 'E1', 'F1', 'F2', 'F3v1', 'F3v2', 'G'].includes(this.onboardingPatient?.flow_variant);
    },
    isAutoSelected() {
      const previousName = this.product?.previousproductname;
      return previousName === 'Estrogen Tablet' || previousName === 'Progesterone Capsule';
    },
    benefitTag(){
      return ['E1', 'F3v1', 'F3v2', 'G'].includes(this.onboardingPatient?.flow_variant)
        ? this.product?.tag
        : 'HSA/FSA-eligible';
    },
    descriptionText() {
      return this.showDescription
        ? this.product.description
        : this.product.shortdescription;
    },
    descriptionTextList() {
      return this.product.description || []
    },
    showMoreText() {
      return this.showDescription ? 'Show less' : 'Show more';
    },
  },
  watch: {
    selected() {
      // if (!this.firstSet) {
      //   this.firstSet = true;
      //   return;
      // }
      if (this.selected && this.selectedpricing == '') {
        this.selectedpricing = this.product.availablepricing[0].pricingid;
      } else if (!this.selected) {
        this.selectedpricing = '';
      }

      this.$emit(
        'set-selection',
        this.product.id,
        this.selected,
        this.selectedpricing,
        this.product.productselect,
        this.product.productdeselect
      );
    },
    selectedpricing() {
      if (this.selected) {
        this.$emit(
          'update-shipping',
          this.product.id,
          this.selectedpricing,
          this.product.productselect,
          this.product.productdeselect,
          this.product.availablepricing
        );
      }
    },
  },
  async mounted() {
    if (this.existingPricing) {
      this.selectedpricing = this.existingPricing;
    } else {
      this.selectedpricing = this.product.availablepricing[0].pricingid;
    }

    if (this.onboardingPatient?.desiredplan?.length > 0) {
      this.selected = this.onboardingPatient.desiredplan.some(plan => {
        return plan.pricingdetail && plan.pricingdetail.pricingid === this.selectedpricing;
      });
    } else {
      this.selected = true;
    }

    if (this.isAutoSelected) {
      this.selected = true;
    }
  },
  methods: {
    setSelected(val) {
      this.selected = val;
      if (!val) {
        this.selectedpricing = '';
      }
    },
    async setPricing(val) {
      if (!this.selected) {
        this.selectedpricing = val;
        this.selected = true;
      } else {
        this.selectedpricing = val;
      }
    },
    setIsDropdownOpen(isOpen) {
      this.isDropdownOpen = isOpen;
    },
    formatPricing(type, price, recurring) {
      let priceString = price
      if (this.isOnboardingRedesign) {
        const [dollars, cents] = price.toString().split('.');
        priceString = cents === '00' ? dollars : price.toFixed(2);
      }

      if (type == 'one_time') {
        if (this.onboardingPatient?.non_hrt) {
          return `$${price} per order`;
        } else {
          return `One time payment of $${price}`;
        }
      } else if (recurring.interval == 'day') {
        const isMoreThanOneMonth = recurring.interval_count / 30 > 1;
        const plural = isMoreThanOneMonth ? 's' : '';
        const interval = isMoreThanOneMonth
          ? Math.ceil(recurring.interval_count / 30) + ' '
          : '';
        return `$${priceString}/${interval}month${plural}`;
      } else {
        return `$${priceString}/${recurring.interval_count}${recurring.interval}(s)`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: absolute;
  top: 10px;
  padding: 5px 10px;
  background: #ff8d40;
  right: 0;
  color: $white;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 10px;
  z-index: 1;
}

.list-inline {
  margin-top: 1.5rem;

  li {
    position: relative;
    width: 50%;
    display: inline-block;

    @include media-breakpoint-down(sm) {
      width: 100%;
    }

    input {
      position: absolute;
      left: -9999px;
    }

    label {
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;

      &:before {
        content: "";
        display: inline-flex;
        flex: 1 150vw;
        width: 15px;
        height: 15px;
        max-width: 15px;
        border-radius: 15px;
        border: 1px solid $primary;
        margin-right: 10px;

        @include media-breakpoint-up(xxl) {
          width: 15px * $scale-font;
          height: 15px * $scale-font;
          max-width: 15px * $scale-font;
          border-radius: 15px * $scale-font;
          margin-right: 10px * $scale-font;
        }
      }
    }

    input:checked + label {
      &:before {
        background-color: $primary;
      }
    }
  }
}

.img-holder {
  width: 100% !important;
  height: calc(100% - 40px);
  background-color: #EBF5F4;
  margin-right: 0 !important;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

html:not(.redesign) {
  .img-holder {
    @include media-breakpoint-down(md) {
      height: 200px !important;
    }
  }
}

::v-deep .v-select-state-select .vs__dropdown-toggle {
  background-color: transparent !important;
  border: 1px solid #C7C7C7 !important;
  border-radius: 10px !important;
}

::v-deep .v-select-state-select .vs__open-indicator {
  fill: #19191C !important;
  transform: scale(1.25) !important;
}

::v-deep .product-reveal-checkbox .checkmark {
  margin-right: 0 !important;
}
</style>
